export default __webpack_public_path__ + "static/realWorldImage4-6fb6abe45d84c80bb59a7279f80dc45e.webp";